import { Component } from '@angular/core';

@Component({
  selector: 'common-chat-messages-icon',
  standalone: true,
  templateUrl: './chat-messages-icon.component.svg',
  styleUrls: ['./chat-messages-icon.component.scss'],
})
export class ChatMessagesIconComponent {
  constructor() {}
}
